import React from 'react';
import { any, string } from 'prop-types';
import { Spinner } from 'react-bootstrap';

import styles from './loaderPage.module.css';

function Loader({ text, children }) {
  return (
    <div className={styles['loader-container']}>
      <div className={styles['loader-page']}>
        <div className={styles['loader-text']}>{text}</div>
        {children}
        <Spinner animation="border" />
      </div>
    </div>
  );
}

Loader.defaultProps = {
  text: 'Loading...',
  children: null,
};

Loader.propTypes = {
  text: string,
  children: any,
};

export default Loader;
